// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const updateAlertApi = (alertId, alert) =>
  api().post(`/alerts/${alertId}`, alert);

export default updateAlertApi;
